(function($) {
  "use strict";

  var injectedStyles = {};
  var $styleSheet = null;

  function ensureStyleSheet() {
    if (!$styleSheet) {
      $styleSheet = $("<style id='grid-slider-combined-styles'></style>").appendTo("head");
    }
    return $styleSheet;
  }

  $.gridSlider = function(element, options) {
    var _ = this,
        defaults = { selector: ".grid-slider", IntersectionObserver: false },
        $element = $(element);
    
    _.settings = {};
    _.init = function() {
      _.settings = $.extend({}, defaults, options);
      _._initSlider();
    };

    _.uniqid = function(length) {
      length = length || 8;
      var result = "", chars = "abcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return result;
    };

    _._initSlider = function() {
      var settings = _.settings,
          elements = $element.find(settings.selector);
      if (!elements.length) elements = $element;

      elements.each(function() {
        var element2 = $(this);
        if (element2.hasClass("grid-init") || element2.hasClass("slick-initialized")) return;

        var isRTL = $("body").hasClass("rtl"),
            uid = _.uniqid(),
            selector = "grid-slider-" + uid;

        element2.addClass(selector);
        selector = "." + selector;

        if (isRTL) {
          element2.attr("dir", "rtl").data("rtl", true);
        }

        var azInit = element2.find("> .slick-list > .slick-track");
        var iClass = ".alo-item";
        if (azInit.length) {
          azInit.children().addClass("alo-item");
        } else {
          element2.children().addClass("alo-item");
        }

        var options2 = element2.data() || {},
            rows = options2.rows === undefined ? 1 : options2.rows,
            padding = options2.padding === undefined ? 0 : options2.padding,
            classes = rows ? selector + " " + iClass : selector + " .slick-track > " + iClass;

        var style = classes + "{padding:0 " + padding + "px;box-sizing:border-box;float:left;min-height:1px;min-width:1px;}" +
                    selector + "{margin:0 -" + padding + "px;}" +
                    selector + ".grid-init{visibility:visible;opacity:1;}";

        if (isRTL) {
          style += ".rtl " + classes + "{float:right;}";
        }

        var responsive = _.getPesponsive(options2);
        if (responsive != null) {
          var len = Object.keys(responsive).length;
          $.each(responsive, function(key, value) {
            var col = 0, maxWidth = 0, minWidth = 0;
            $.each(value, function(size, num) {
              minWidth = parseInt(size) + 1;
              col = num;
            });
            if (key + 2 < len) {
              $.each(responsive[key + 1], function(size, num) {
                maxWidth = size;
                col = num;
              });
              style += " @media (min-width:" + minWidth + "px) and (max-width:" + maxWidth + "px){" +
                       classes + "{width:calc(100% / " + col + ");}}";
            } else if (key + 2 === len) {
              $.each(responsive[key], function(size, num) {
                maxWidth = size;
                col = num;
              });
              style += " @media (min-width:" + maxWidth + "px){" +
                       classes + "{width:calc(100% / " + col + ");}}";
            }
          });
        }

        if (!injectedStyles[selector]) {
          injectedStyles[selector] = true;
          ensureStyleSheet().append(style);
        }

        element2.addClass("grid-init");

        if (options2.appendArrows || options2.appendDots) {
          var wrapper = options2.wrapper ? element2.find(options2.wrapper) : element2.parent();
          if (options2.appendArrows) element2.data("append-Arrows", wrapper.find(options2.appendArrows));
          if (options2.appendDots) element2.data("append-Dots", wrapper.find(options2.appendDots));
        }

        _.sliderRender(element2);
      });
      return this;
    };

    _.getPesponsive = function(options2) {
      if (options2.responsive) {
        if (!options2.slidesToShow) return options2.responsive.slice().reverse();
        var resp = options2.responsive,
            gridResp = [];
        $.each(resp, function(key, value) {
          var bp = {};
          bp[value.breakpoint] = parseInt(value.settings.slidesToShow);
          gridResp.push(bp);
        });
        return gridResp.reverse();
      }
      return null;
    };

    _.sliderRender = function(el) {
      if (el.hasClass("slick-initialized") || typeof el.slick !== "function") return;
      var opts = el.data() || {};
      el.slick(opts);
    };

    _.init();
  };

  $.fn.gridSlider = function(options) {
    return this.each(function() {
      if (!$(this).data("gridSlider")) {
        var plugin = new $.gridSlider(this, options);
        $(this).data("gridSlider", plugin);
      }
    });
  };

  function initSlidersLazy() {
    if (typeof $.fn.slick !== "function") {
      setTimeout(initSlidersLazy, 60);
      return;
    }

    var $sliders = $(".grid-slider").not("grid-slider, .exception, .grid-init, .slick-initialized");
    if (!$sliders.length) return;

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(function(entries, obs) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var target = entry.target;
            obs.unobserve(target);
            if (!$(target).hasClass("grid-init")) {
              $(target).gridSlider();
            }
          }
        });
      }, { rootMargin: "300px 0px" });

      $sliders.each(function(idx, el) {
        if (idx < 2) {
          $(el).gridSlider();
        } else {
          observer.observe(el);
        }
      });
    } else {
      $sliders.each(function() {
        $(this).gridSlider();
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSlidersLazy);
  } else {
    initSlidersLazy();
  }

})(window.$$ || jQuery);